import request from '@/utils/request'

export function getTokenConfig () {
    return request({
        url: 'oauth/lynk',
        method: 'get'
    })
}

export function getToken (code) {
    const redirect_uri = sessionStorage.getItem('redirect_uri') == null? encodeURIComponent(window.location.href) : sessionStorage.getItem('redirect_uri')
    return request({
        url: 'oauth/lynk',
        method: 'post',
        data: {
            code,
            redirect_uri
        }
    })
}
